<template>
  <div class="password">
    <section class="left-panel">
      <header>
        <div class="grid-container top">
          <div class="col-4">
            <img class="logo" src="../../assets/images/global/logo.svg">
            <router-link to="/login" class="btn bg-three active">Log In</router-link>
          </div>
        </div>
      </header>
      <div class="grid-container">
        <div class="col-4 vertical-centre">
          <div class="left-panel-centre">
            <h1><span>Great, let's keep your</span> account safe</span></h1>
            <form @submit.prevent="register">
              <input :class="{ success: isSuccess, error: hasError }" type="password" pattern=".{6,}" v-model.trim="password" placeholder="Password" required />
              <input :class="{ success: isSuccess, error: hasError }" type="password" pattern=".{6,}" v-model.trim="confirmPassword" placeholder="Confirm Password" required />
              <input class="btn btn-big bg-four active" type="submit" value="Set Password">
              <p class="feedback" v-show="hasError">{{ message }}</p>
            </form>
          </div>
        </div>
        <ul class="bottom">
          <li><a target="_blank" href="http://planetearthinstitute.org.uk" class="link blue">Visit PEI Website</a></li>
          <li><router-link to="terms" class="link navy">Terms &amp; Conditions</router-link></li>
        </ul>
      </div>
    </section>

    <section class="hero-image">
    </section>
  </div>
</template>

<script>
import { auth } from '@/firebase'

export default {
  name: 'Register',
  data () {
    return {
      password: '',
      confirmPassword: '',
      message: '',
      isSuccess: false,
      hasError: false
    }
  },
  methods: {
    register () {
      document.getElementsByTagName('input').disabled = true
      if (this.password === this.confirmPassword) {
        this.hasError = false
        this.message = ''
        let parent = this
        let user = auth.currentUser
        user.updatePassword(this.password).then(function () {
          parent.isSuccess = true

          // Update successful.
          parent.$parent.currentStep++
        }, function (error) {
          // An error happened.
          document.getElementsByTagName('input').disabled = false
          console.error(error.message)
          parent.message = error.message
          parent.isSuccess = false
          parent.hasError = true
        })
      } else {
        console.error('Passwords dont match')
        this.message = 'Please make sure both passwords match.'
        this.isSuccess = false
        this.hasError = true
      }
    }
  },
  watch: {
    password: function (val) {
      this.hasError = false
    },
    confirmPassword: function (val) {
      this.hasError = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// Register-Step-2.vue?14ee155c